export default {"src":"/_next/static/media/nexo.5f16df12.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};